import { useTranslate } from 'core/hooks/useTranslate';
import { useLemonadeViewer } from 'core/modules/components/lemonade/hook/useLemonadeViewer';
import { useEffect, useState } from 'react';

function getInfoToLemonade(item) {
  let data = {};
  if (item?.data) {
    data = item;
  } else {
    data = { ...item, data: item };
  }

  return { ...data, reference: data.reference ? data.reference : `${new Date().getTime()}` };
}

const useDialogActivityPreview = ({ activity }) => {
  const { Question, showCorrectAnswer, resetQuestion } = useLemonadeViewer({
    data: getInfoToLemonade(activity?.data || JSON.parse(activity?.question_data)),
    disableInteraction: true,
  });
  const { t } = useTranslate();
  const [background, setBackground] = useState(null);

  useEffect(() => {
    if (activity?.data?.ui_style?.background) {
      setBackground(activity.data.ui_style.background);
    }
  }, [activity]);

  return {
    Question,
    showCorrectAnswer,
    resetQuestion,
    t,
    background,
  };
};

export default useDialogActivityPreview;
